"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIs = exports.isLimitedDataSize = void 0;
var getByteLength_1 = require("../utils/getByteLength");
var js_md5_1 = require("js-md5");
var DATA_SIZE_LIMIT = 65536;
var DATA_SIZE_LIGHT = 32768;
function isLimitedDataSize(str) {
    if (str.length > DATA_SIZE_LIMIT) {
        return false;
    }
    if (str.length <= DATA_SIZE_LIGHT) {
        return true;
    }
    return (0, getByteLength_1.getByteLength)(str) <= DATA_SIZE_LIMIT;
}
exports.isLimitedDataSize = isLimitedDataSize;
function apmSigHeader(apiKey, data) {
    var timestamp = +new Date();
    var nonce = Math.floor(Math.random() * 2147483647);
    return JSON.stringify({
        api_key: apiKey,
        time_stamp: timestamp,
        nonce: nonce,
        obf_sig: (0, js_md5_1.md5)(apiKey + "_" + timestamp + "_" + nonce + "_" + data),
    });
}
exports.APIs = {
    inited: false,
    supportFetch: typeof window.fetch === 'function',
    supportFetchKeepAlive: typeof window.fetch === 'function' && 'keepalive' in new Request(''),
    supportSendBeacon: typeof (navigator === null || navigator === void 0 ? void 0 : navigator.sendBeacon) === 'function',
    isLimitedDataSize: function (data) {
        return data.byteLength <= DATA_SIZE_LIMIT;
    },
    fetchPost: function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var url, data, token, apiKey, dataStr, useKeepalive, res, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = props.url, data = props.data, token = props.token, apiKey = props.apiKey;
                        if (!this.supportFetchKeepAlive) return [3, 3];
                        dataStr = JSON.stringify(data);
                        useKeepalive = isLimitedDataSize(dataStr);
                        return [4, fetch(url, {
                                method: 'POST',
                                headers: __assign(__assign({ 'Content-Type': 'application/json', Accept: 'application/json' }, (token
                                    ? {
                                        Authorization: "Bearer " + token,
                                    }
                                    : {})), (apiKey
                                    ? {
                                        'Apm-Signature-Headers': apmSigHeader(apiKey, dataStr),
                                    }
                                    : {})),
                                keepalive: useKeepalive,
                                body: dataStr,
                            })];
                    case 1:
                        res = _a.sent();
                        return [4, res.json()];
                    case 2:
                        response = _a.sent();
                        if (res.status === 200) {
                            return [2, response];
                        }
                        return [2, Promise.reject(response)];
                    case 3: return [2, false];
                }
            });
        });
    },
    postXHR: function (props) {
        var url = props.url, data = props.data, _a = props.async, async = _a === void 0 ? true : _a, token = props.token, apiKey = props.apiKey;
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', url, async);
            xhr.setRequestHeader('Content-Type', 'application/json');
            if (token) {
                xhr.setRequestHeader('Authorization', "Bearer " + token);
            }
            if (apiKey) {
                xhr.setRequestHeader('Apm-Signature-Headers', apmSigHeader(apiKey, JSON.stringify(data)));
            }
            xhr.addEventListener('readystatechange', function () {
                if (xhr.readyState === XMLHttpRequest.DONE) {
                    if (xhr.status === 200) {
                        var result = xhr.response;
                        try {
                            result = JSON.parse(result);
                        }
                        catch (error) {
                        }
                        return resolve(result);
                    }
                    else {
                        return reject(xhr.response);
                    }
                }
            });
            xhr.send(JSON.stringify(data));
        });
    },
};
